import React from 'react'
import { Link } from 'react-router-dom'
import './footer.module.css'
import { Row, Col, Container } from 'react-bootstrap'

const Footer: React.FC = () => {
  return (
    <footer>
      <Container fluid>
        <Row className="no-gutters py-4">
          <Col></Col>
          <Col xs="auto" className="text-right">
            <Link to="/policies/terms-of-service">Terms of Service</Link>
          </Col>
          <Col xs="auto" className="text-center mx-4">
            <Link to="/policies/privacy-policy">Privacy Policy</Link>
          </Col>
          <Col xs="auto" className="text-left">
            <Link to="/policies/refund-policy">Refund Policy</Link>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
